import { CommonModule } from '@angular/common';
import { Component, NgZone } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { Subject, debounceTime, distinctUntilChanged } from 'rxjs';
import { ContactPlace } from '../../core/models';
import { HttpService, StateService } from '../../core/services';
import { LoadingComponent, SearchInputComponent } from '../../shared/components';
import { TranslationPipe } from '../../shared/pipes';
import { LayerService } from '../map/services';
import { ContactPlacesState } from './contact-places-state';

@Component({
  selector: 'app-contact-places',
  standalone: true,
  imports: [CommonModule, FormsModule, RouterLink, SearchInputComponent, TranslationPipe, LoadingComponent],
  templateUrl: './contact-places.component.html',
  styleUrl: './contact-places.component.scss',

})
export class ContactPlacesComponent {
  private readonly searchSubject = new Subject<string>;
  public term: string = "";
  state: ContactPlacesState;
  placeId: string | undefined = undefined;
  loading = false;

  constructor(
    private readonly ngZone: NgZone,
    private readonly route: ActivatedRoute,
    private readonly stateService: StateService,
    private readonly httpService: HttpService,
    private readonly layerService: LayerService)
  {
    this.state = this.stateService.read<ContactPlacesState>('ContactPlacesState') ?? new ContactPlacesState();
  }

  ngOnInit() {
    this.route.paramMap.subscribe((params) => {
      this.ngZone.run(() => {
        this.placeId = params.get('id') ?? '';
        if (this.placeId.length > 0) {
          this.state.searchedPlaces = [];
          if (!isNaN(+this.placeId)) {
              this.httpService.getContactPlace(+this.placeId).subscribe({
                next: result => {
                  this.filterOpeningHours(result);
                  this.state.searchedPlaces.push(result);
                  this.stateService.store('ContactPlacesState', this.state);
                }
              });
          }
        }
      });
    });

    this.searchSubject.pipe(debounceTime(300), distinctUntilChanged()).subscribe((searchValue) => {
      this.searchTextChange(searchValue);
    });
  }

  contactClick(place: ContactPlace) {
      this.layerService?.moveToContactPlace(place.id, place.lat, place.lon);
      place.isExpanded = !place.isExpanded;
  }

  onSearch(term: string) {
    this.term = term;
    if (term && term.trim().length !== 0)
      this.searchSubject.next(term);
    else
      this.state.searchedPlaces = [];
  }

  private searchTextChange(input: string) {
    this.state.searchText = input;
    this.state.searchedPlaces = [];

    this.ngZone.run(() => {
      this.httpService.findContactPlaces(this.state.searchText).subscribe({
        next: result => {
          result.forEach(r => {
            const cp = r as ContactPlace;
            this.filterOpeningHours(cp);
            this.state.searchedPlaces.push(cp);
          })

          this.stateService.store('ContactPlacesState', this.state);
        }
      });
    });
  }

  private filterOpeningHours(cp: ContactPlace) {
    cp.openingHours = cp.openingHours.filter(h => h.from.length > 0 || h.hours.length > 0);
  }
}
